<script>
    import List, {Group, Item, Graphic, Meta, Label, Separator, Subheader, Text, PrimaryText, SecondaryText} from '@smui/list';
    import { allTemplateFields } from "../../Participaid.svelte";
    import ProjectField from "../../models/participaid/ProjectField.js";
    import Util from "../../lib/util.js";
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    import Button from "../form/Button.svelte";
    import ProjectFieldSummary from "./ProjectFieldSummary.svelte";
    import Overlay from "../Overlay.svelte";
    import EditProjectFieldDialog from "../dialogs/EditProjectFieldDialog.svelte";
    import Notification from "../Notification.svelte";

    export let fields = [];
    export let editable = false;
    export let saveable = false;
    export let deleteable = true;
    export let allowNew = true;
    export let showTemplates = true;
    export let projectId;

    let selection = [];
    let toDelete = [];
    let showNewFieldDialog = false;
    let hadFields = !showTemplates;
    let loadingErrorMsg = "";
    let saveErrorMsg = "";
    let saveSuccessMsg = "";
    let saveRequest;

    $: hasFields = fields.length;

    $: {
        console.log(`has fields: ${hasFields}`);
        console.log(`fields:`);
        console.log(fields);
    }

    // load templates
    if (!fields.length && showTemplates) {
        console.log(`loading field templates for ProjectFieldSelectionList...`);

        allTemplateFields()
            .then(res => {
                fields = res.data.templateFields.map(ProjectField.clean);
                hadFields = true;
            })
            .catch(err => {
                loadingErrorMsg = "Could not load template fields. Try again later";
            })
    }

    const close = () => showNewFieldDialog = false;
    const showNewDialog = () => showNewFieldDialog = true;

    function handleNewField(evt) {
        console.log(`received new field from EditProjectFieldDialog:`);
        console.log(evt.detail);

        fields = [...[evt.detail], ...fields];
        close();
    }

    function handleUpdateField(evt) {
        let old = evt.detail.old;
        let newish = evt.detail.new;
        fields = [...(Util.removeItemOnce(fields, old)), newish];
    }

    function handleDeleteField(evt) {
        let beforeLen = fields.length;
        fields = Util.removeItemOnce(fields, evt.detail);
        dispatch("delete", evt.detail);
        if (beforeLen == fields.length) {
            console.error("tried removing project field model from ProjectFieldSelectionList, but failed!");
        }
    }

    function handleDeleteAll() {
        if (confirm("Are you sure you want to delete all fields?")) {
            toDelete = fields;
            fields = [];
            console.log(`ProjectFieldSelectionList cleared fields`);
            dispatch("deleteAll", fields);
        }
    }

    function handleSaveAll() {
        if (confirm("Are you sure you want to save all fields?")) {
            saveRequest = ProjectField.overwriteAll(projectId, fields)
                .then(res => {
                    saveRequest = null;
                    saveSuccessMsg = "Successfully saved fields";
                    dispatch("save", res);
                })
                .catch(err =>
                    saveErrorMsg = "There was an error trying to save fields"
                )
        }
    }

</script>

{#if editable}
    <div class="actions">
        {#if deleteable}
            <a href="#" class="action-delete-all" on:click|preventDefault={handleDeleteAll} style="color: #c00">
                Delete all...
            </a>
        {/if}
        {#if saveable}
            {#if saveRequest}
                <a href>...</a>
            {:else}
                <a href="#" class="action-save" on:click|preventDefault={handleSaveAll}>
                    Save...
                </a>
            {/if}
        {/if}
        {#if allowNew}
            <a href="#" class="action-add-new" on:click|preventDefault={showNewDialog}>
                Add new...
            </a>
        {/if}
    </div>
{/if}

<List class="demo-list" threeLine checklist style="max-height: 400px; overflow-y: scroll; clear: both;">
    {#if hasFields}
        {#each fields as field}
            {#if !field.name.startsWith("__")}
                <ProjectFieldSummary
                        bind:selection={selection}
                        selected
                        {editable}
                        model={field}
                        on:delete={handleDeleteField}
                        on:update={handleUpdateField}
                />
            {/if}
        {/each}
    {:else if hadFields}
        <p>No fields defined yet!</p>

        {#if allowNew}
            <p><Button on:click={showNewDialog}>Define new field...</Button></p>
        {/if}
    {:else if loadingErrorMsg}
        {loadingErrorMsg}
    {:else}
        loading...
    {/if}
</List>

{#if showNewFieldDialog}
    <Overlay show={showNewFieldDialog} closable={true} background="darken" loaderBackground="#333A" on:close={close}>
        <EditProjectFieldDialog
                show={showNewFieldDialog}
                on:new={handleNewField}
                on:close={close}
        />
    </Overlay>
{/if}

<Notification type="success" message={saveSuccessMsg} />

<style>
    .actions {
        display: flex;
        flex-direction: row;
    }

    .actions a {
        text-transform: uppercase;
        font-size: 11px;
        //display: inline-block;
        font-weight: bold;
        margin-bottom: 10px;
        flex: 1;
    }

    .actions .action-delete-all {
        //float: left;

    }

    .actions .action-add-new {
        //float: right;
        text-align: right;
    }

    .actions .action-save {
        text-align: center;
    }

    p {
        text-align: center;
    }
</style>